import { initialCreateMap } from "./componentMaps";
import { editableElements, page_keys, portal_keys } from "./config"

export const edit_register_return_keys = {
    SECTION: "section",
    HEADER: "header",
    ORDERNUMBER: "orderNumber",
    ORDERNUMBERTEXT: "orderNumberText",
    ORDERNUMBERINPUT: "orderNumberInput",
    EMAIL: "email",
    EMAILTEXT: "emailText",
    EMAILINPUT: "emailInput",
    REQUESTRETURNBUTTON: "requestReturnButton",
}

export const editRegisterReturnMap = {
    [edit_register_return_keys.SECTION]: portal_keys.SECTION,

    [edit_register_return_keys.HEADER]: portal_keys.HEADER_TEXT,

    [edit_register_return_keys.ORDERNUMBER]: portal_keys.INPUT_CONTAINER,
    [edit_register_return_keys.ORDERNUMBERTEXT]: portal_keys.INPUT_CONTAINER_TEXT,
    [edit_register_return_keys.ORDERNUMBERINPUT]: portal_keys.INPUT_CONTAINER_INPUT,

    [edit_register_return_keys.EMAIL]: portal_keys.INPUT_CONTAINER,
    [edit_register_return_keys.EMAILTEXT]: portal_keys.INPUT_CONTAINER_TEXT,
    [edit_register_return_keys.EMAILINPUT]: portal_keys.INPUT_CONTAINER_INPUT,

    [edit_register_return_keys.REQUESTRETURNBUTTON]: portal_keys.BUTTON,
}


export const edit_order_lines_to_return_keys = {
    SECTION: "section",
    HEADER: "header",
    TORETURNCONTAINER: "toReturnContainer",
    ITEMCANBERETURNEDCONTAINER: "itemCanBeReturnedContainer",

    ITEMAMOUMTTORETURNDROPDOWN: "itemAmountToReturnDropdown",
    ITEMREASONTORETURNDROPDOWN: "itemReasonToReturnDropdown",
    ITEMTORETURNREMARKINPUT: "itemToReturnRemarkInput",

    ITEMCANNOTBERETURNEDCONTAINER: "itemCanNotBeReturnedContainer",

    TORETURNFURTHERDETAILS: "toReturnFurtherDetails",
    CREATERETURNBUTTON: "createReturnButton",
}


export const editOrderLinesMap = {
    [edit_order_lines_to_return_keys.SECTION]: portal_keys.SECTION,

    [edit_order_lines_to_return_keys.HEADER]: portal_keys.HEADER_TEXT,

    [edit_order_lines_to_return_keys.TORETURNCONTAINER]: portal_keys.CONTAINER,
    [edit_order_lines_to_return_keys.ITEMCANBERETURNEDCONTAINER]: portal_keys.SECONDARY_CONTAINER,
    [edit_order_lines_to_return_keys.ITEMAMOUMTTORETURNDROPDOWN]: portal_keys.DROPDOWN,
    [edit_order_lines_to_return_keys.ITEMREASONTORETURNDROPDOWN]: portal_keys.DROPDOWN,
    [edit_order_lines_to_return_keys.ITEMTORETURNREMARKINPUT]: portal_keys.INPUT_CONTAINER_INPUT,

    [edit_order_lines_to_return_keys.ITEMCANNOTBERETURNEDCONTAINER]: portal_keys.SECONDARY_CONTAINER,

    [edit_order_lines_to_return_keys.TORETURNFURTHERDETAILS]: portal_keys.CONTAINER,

    [edit_order_lines_to_return_keys.CREATERETURNBUTTON]: portal_keys.BUTTON,
}

export const edit_order_lines_confirm_KEYS = {
    SECTION: "section",

    TORETURNCONTAINER: "toReturnContainer",
    LINECONTAINER: "lineContainer",

    RETURNSHIPPERCONTAINER: "returnShipperContainer",
    RETURNSHIPPERDETAILS: "returnShipperDetails",

    PREVIOUSSTEPBUTTON: "previousStepButton",
    CONFIRMRETURNBUTTON: "confirmReturnButton",
}

export const editOrderLinesConfirmMap = {
    [edit_order_lines_confirm_KEYS.SECTION]: portal_keys.SECTION,

    [edit_order_lines_confirm_KEYS.TORETURNCONTAINER]: portal_keys.CONTAINER,
    [edit_order_lines_confirm_KEYS.LINECONTAINER]: portal_keys.SECONDARY_CONTAINER,

    [edit_order_lines_confirm_KEYS.RETURNSHIPPERCONTAINER]: portal_keys.CONTAINER,
    [edit_order_lines_confirm_KEYS.RETURNSHIPPERDETAILS]: portal_keys.SECONDARY_CONTAINER,

    [edit_order_lines_confirm_KEYS.PREVIOUSSTEPBUTTON]: portal_keys.SECONDARY_BUTTON,
    [edit_order_lines_confirm_KEYS.CONFIRMRETURNBUTTON]: portal_keys.BUTTON,
}


export const edit_return_submitted_keys = {
    SECTION: "section",

    INFOCONTAINER: "infoContainer",
    
    DOWNLOADLABELBUTTON: "downloadLabelButton",
}

export const editReturnSubmittedMap = {
    [edit_return_submitted_keys.SECTION]: portal_keys.SECTION,

    [edit_return_submitted_keys.INFOCONTAINER]: portal_keys.CONTAINER,

    [edit_return_submitted_keys.DOWNLOADLABELBUTTON]: portal_keys.BUTTON,
}


export const edit_return_status_page_keys = {
    SECTION: "section",
}

export const editReturnStatusPageMap = {
    [edit_return_status_page_keys.SECTION]: portal_keys.SECTION,
}

export const defaultData = {
    savedColors: Array.from({ length: 12 }, () => editableElements.BACKGROUNDCOLOR),
}

